import axios from '../config/axios';
import { getApiUrl } from '../config/environment';
import { openSignedMedicalReportPdf } from '../services/documentSignatureService';
import { buildMedicalReportPrintHtml } from './medicalReportPrintDocument';
import { isSignedMedicalReport } from './medicalReportSignature';
import { escapeHtml } from './clinicPrintLetterhead';
import { printClinicHtml } from './clinicPrintHtml';

export async function fetchLinkedMedicalReport(reportId: string): Promise<any | null> {
  try {
    const { data } = await axios.get(getApiUrl(`/clinic/medical-reports/${reportId}`));
    return data?.data ?? null;
  } catch {
    return null;
  }
}

export function buildSignedMedicalReportNoticeHtml(report: any): string {
  const code = report.signature_verification_code || '—';
  const title = report.title || 'Relatório médico';
  return `<div class="attachment-block attachment-block--embedded" style="padding:16px;border:1px solid #99f6e4;border-left:4px solid #0d9488;background:#f0fdfa;border-radius:6px;">
    <div style="font-size:11px;font-weight:700;color:#0f766e;text-transform:uppercase;">Relatório médico assinado digitalmente</div>
    <div style="font-size:12px;color:#111;margin-top:6px;font-weight:600;">${escapeHtml(title)}</div>
    <div style="font-size:11px;color:#374151;margin-top:4px;line-height:1.6;">
      O documento com validade legal é o PDF assinado em ICP-Brasil.
      Código de conferência: <strong>${escapeHtml(code)}</strong>
    </div>
    <div style="font-size:10px;color:#6b7280;margin-top:6px;">O PDF assinado será aberto em outra aba ao imprimir este pacote.</div>
  </div>`;
}

export type MedicalReportPrintPart =
  | { kind: 'html'; html: string }
  | { kind: 'signed'; report: any };

export async function resolveMedicalReportPrintPart(
  reportId: string,
  extractBodyInner: (fullHtml: string) => string,
): Promise<MedicalReportPrintPart | null> {
  const report = await fetchLinkedMedicalReport(reportId);
  if (!report) return null;

  if (isSignedMedicalReport(report)) {
    return { kind: 'signed', report };
  }

  try {
    const { data } = await axios.get(getApiUrl(`/clinic/medical-reports/${reportId}/print`));
    const printData = data?.data ?? data;
    const full = buildMedicalReportPrintHtml(printData);
    return {
      kind: 'html',
      html: `<div class="attachment-block attachment-block--embedded">${extractBodyInner(full)}</div>`,
    };
  } catch {
    return null;
  }
}

/** Imprime um relatório médico vinculado à evolução: PDF assinado ou HTML de rascunho. */
export async function printSingleLinkedMedicalReport(reportId: string): Promise<void> {
  const report = await fetchLinkedMedicalReport(reportId);
  if (!report) throw new Error('Relatório médico não encontrado.');

  if (isSignedMedicalReport(report)) {
    await openSignedMedicalReportPdf(report.id, report.signed_pdf_url);
    return;
  }

  const { data } = await axios.get(getApiUrl(`/clinic/medical-reports/${reportId}/print`));
  const printData = data?.data ?? data;
  printClinicHtml(buildMedicalReportPrintHtml(printData));
}
